import React from "react";
import { useParams } from "react-router";
import { SingleAccountPage } from "./SingleAccountPage";

export const SingleAccountByParamPage = () => {
  const { accountId } = useParams<"accountId">();
  return <SingleAccountPage accountId={Number.parseInt(accountId!, 10)} />;
};
